import React from 'react';
import { motion } from 'framer-motion';
import AutomationSettings from '@/components/settings/AutomationSettings';

export function Automations() {
  return (
    <div className="space-y-6">
      <div className="flex flex-col space-y-2">
        <motion.h1 
          className="text-3xl font-bold tracking-tight"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3 }}
        >
          Automations
        </motion.h1>
        <motion.p 
          className="text-muted-foreground"
          initial={{ opacity: 0, y: -10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.3, delay: 0.1 }}
        >
          Set up automated workflows to streamline your church operations and member engagement.
        </motion.p>
      </div>
      
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3, delay: 0.2 }}
      >
        <AutomationSettings />
      </motion.div>
    </div>
  );
}
